import { useState } from 'react';

import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';
import { AccountHolder } from 'src/models';

import { DisclosuresForm } from './DisclosuresForm';
import { DisclosuresView } from './DisclosuresView';

interface OtherAccountHolderDisclosureSectionProps {
  accountHolder: AccountHolder;
}

export const OtherAccountHolderDisclosureSection = ({ accountHolder }: OtherAccountHolderDisclosureSectionProps) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  return (
    <MFormSection title='Disclosures' onEdit={onEdit} isEditable isEditMode={isEditMode} testId={'other-disclosures'}>
      {!isEditMode ? (
        <DisclosuresView accountHolder={accountHolder} isPrimary={false} />
      ) : (
        <DisclosuresForm
          accountUuid={account?.id}
          accountHolder={accountHolder}
          isPrimary={false}
          onCancel={onCancel}
          testId={'joint'}
        />
      )}
    </MFormSection>
  );
};
